import React from "react";
import {
    SCHEDULES_REPORT_ROWS_LABELS,
    SchedulesReportLayout,
    SchedulesReportRows,
} from "@common/types/reports/schedules-report";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { getSchedulesReportRowsOptions } from "./schedulesReportFilterRules";

interface Props {
    value: SchedulesReportRows;
    layout: SchedulesReportLayout;
    onChange: (rows: SchedulesReportRows) => void;
    className?: string;
}

export const SchedulesReportRowsSelect: React.FC<Props> = ({
    value,
    layout,
    onChange,
    className,
}) => (
    <Picker.Select
        items={getSchedulesReportRowsOptions(layout).map(
            (option): PickerItemData<SchedulesReportRows> => ({
                value: option,
                label: SCHEDULES_REPORT_ROWS_LABELS[option],
            }),
        )}
        value={value}
        onValueChange={(next) => {
            if (next) {
                onChange(next);
            }
        }}
        trigger={
            <Picker.Button variant="primary" size="md" className={className} />
        }
    />
);
